export default "<div class=\"spacer5\"></div>\n<div class=\"spacer1\"></div>\n<app-form [preText]=\"emailText\"></app-form>\n"